<h2 class="f-w-500 m-b-24" mat-dialog-title><strong>{{action}}</strong></h2>
<mat-dialog-content style="max-width: 800px">
  <div class="col-xl-12">
    <mat-card class="cardWithShadow theme-card">
      <mat-card-content class="p-5">
        <form #userForm="ngForm" id="usuarioForm">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                  <mat-icon matPrefix class="op-5">user</mat-icon>
                </div>
                Datos Usuario
              </ng-template>
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <div class="row">
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Rut</mat-label>
                      <input type="text" autocomplete="off" matInput required [disabled]="local_data.run != null"
                        id="rundv" name="rundv" [(ngModel)]="local_data.rundv" toUppercase
                        (focusout)="local_data.rundv != null? onFocusOutRutEvent($event) : null;" placeholder="Run" />
                      <mat-icon matPrefix class="op-5">badge</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Nombres</mat-label>
                      <input type="text" autocomplete="off" matInput required id="nombres" name="nombres"
                        [(ngModel)]="local_data.nombres" toUppercase placeholder="Nombres" />
                      <mat-icon matPrefix class="op-5">person</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>1er Apellido</mat-label>
                      <input type="text" autocomplete="off" matInput required id="apellidoPaterno"
                        name="apellidoPaterno" [(ngModel)]="local_data.apellidoPaterno" toUppercase
                        placeholder="1er Apellido" />
                      <mat-icon matPrefix class="op-5">person</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>2do Apellido</mat-label>
                      <input type="text" autocomplete="off" matInput required id="apellidoMaterno"
                        name="apellidoMaterno" [(ngModel)]="local_data.apellidoMaterno" toUppercase
                        placeholder="2do Apellido" />
                      <mat-icon matPrefix class="op-5">person</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Correo corporativo</mat-label>
                      <input type="text" autocomplete="off" matInput required id="correoCorporativo"
                        name="correoCorporativo" [(ngModel)]="local_data.correoCorporativo" toUppercase
                        placeholder="Correo corporativo" />
                      <mat-icon matPrefix class="op-5">email</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Correo personal</mat-label>
                      <input type="text" autocomplete="off" matInput id="correoPersonal" name="correoPersonal"
                        [(ngModel)]="local_data.correoPersonal" toUppercase placeholder="Correo personal" />
                      <mat-icon matPrefix class="op-5">email</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2">
                    <button mat-flat-button 
                      (click)="seleccionarPerfiles(local_data.perfiles)" color="primary" class="w-100"
                      #tooltip="matTooltip" matTooltip="Editar perfiles usuario" matTooltipPosition="above">
                      <mat-icon class="m-r-10 cursor-pointer">edit</mat-icon>
                    </button>
                  </div>
                  <div class="col-lg-10">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Perfil predeterminado</mat-label>
                      <mat-select required id="nombrePerfil" name="nombrePerfil" [(ngModel)]="local_data.idPerfil"
                        (selectionChange)="onPerfilChange($event)" placeholder="Perfil predeterminado">
                        <mat-option id="PerfilFor" *ngFor="let perfil of local_data.perfiles"
                          value="{{perfil.idPerfil}}">
                          {{perfil.nombrePerfil}}
                        </mat-option>
                      </mat-select>
                      <mat-icon matPrefix class="op-5">supervised_user_circle</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Nombre usuario</mat-label>
                      <input type="text" autocomplete="off" matInput [required]="!isDisableUserPass"
                        [disabled]="isDisableUserPass" id="nombreUsuario" name="nombreUsuario"
                        [(ngModel)]="local_data.nombreUsuario" toUppercase placeholder="Nombre usuario" />
                      <mat-icon matPrefix class="op-5">verified_user</mat-icon>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Clave usuario</mat-label>
                      <input [type]="password" autocomplete="off" matInput [required]="!isDisableUserPass"
                        [disabled]="isDisableUserPass" id="claveUsuario" name="claveUsuario"
                        [(ngModel)]="local_data.claveUsuario" placeholder="Clave usuario" />
                      <mat-icon matPrefix class="op-5">password</mat-icon>
                      <mat-icon matSuffix class="op-5" (click)="onClick($event)" *ngIf="!show">lock</mat-icon>
                      <mat-icon matSuffix class="op-5" (click)="onClick($event)" *ngIf="show">lock_open</mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                  <mat-icon matPrefix class="op-5">user</mat-icon>
                </div>
                Datos Laborales
              </ng-template>
              <div class="bg-light-primary mat-body-1 p-16 rounded m-t-12">
                <div class="row">
                  <div class="col-lg-12">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Dirección Regional</mat-label>
                      <mat-select (selectionChange)="onDireccionRegionalChange($event)" placeholder="Dirección Regional"
                        required id="direccionRegional" name="direccionRegional"
                        [(ngModel)]="local_data.direccionRegional">
                        <mat-option *ngFor="let direccionRegional of direccionesRegionales"
                          value="{{direccionRegional.nombreDireccionRegional}}">
                          {{direccionRegional.nombreDireccionRegional}}
                        </mat-option>
                      </mat-select>
                      <mat-icon matPrefix class="op-5">my_location</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Comuna</mat-label>
                      <mat-select placeholder="Comuna" required id="comuna" name="comuna"
                        [disabled]="local_data.direccionRegionalNumero == 0" [(ngModel)]="local_data.comuna"
                        (selectionChange)="onComunaChange($event)">
                        <mat-option *ngFor="let comuna of comunas" value="{{comuna.nombreComuna}}">
                          {{comuna.nombreComuna}}
                        </mat-option>
                      </mat-select>
                      <mat-icon matPrefix class="op-5">my_location</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-6">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>Tipo unidad</mat-label>
                      <mat-select placeholder="Tipo unidad" required id="tipoUnidad" name="tipoUnidad"
                        [disabled]="local_data.direccionRegionalNumero == 0" [(ngModel)]="local_data.tipoUnidad"
                        (selectionChange)="onTipoUnidadChange($event)">
                        <mat-option value="OFICINA"> OFICINA </mat-option>
                        <mat-option value="JARDÍN"> JARDÍN </mat-option>
                      </mat-select>
                      <mat-icon matPrefix class="op-5">work</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="col-lg-12">
                    <form [formGroup]="unidadForm" id="unidadFormX" name="unidadFormX">
                      <mat-form-field id="mffU" name="mffU" appearance="outline" class="w-100 hide-hint">
                        <mat-label>Unidad</mat-label>
                        <input type="text" autocomplete="off" matInput required id="unidad" name="unidad"
                          [(ngModel)]="local_data.unidad" oninput="this.value = this.value.toUpperCase()"
                          placeholder="Unidad u Oficina" formControlName="unidadGroup"
                          [matAutocomplete]="autoGroup2" />
                        <mat-icon matPrefix class="op-5">business</mat-icon>
                        <mat-autocomplete id="uniau" name="uniau" #autoGroup2="matAutocomplete"
                          (optionSelected)="unidadSeleccionada($event.option.value)">
                          <mat-optgroup id="unidadg" name="unidadg" *ngFor="let unidadgroup of unidadGroupOptions | async" [label]="unidadgroup.letraUnidad">
                            <mat-option id="uni" name="uni" *ngFor="let nameunidad of unidadgroup.nombresUnidad" [value]="nameunidad">
                              {{ nameunidad.toString().split('|')[1] }}
                            </mat-option>
                          </mat-optgroup>
                        </mat-autocomplete>
                      </mat-form-field>
                    </form>
                  </div>

                  <div class="col-lg-12">
                    <form [formGroup]="cargoForm" id="cargoFormX" name="cargoFormX">
                      <mat-form-field id="mffX" name="mffX" appearance="outline" class="w-100 hide-hint">
                        <mat-label>Cargo</mat-label>
                        <input type="text" autocomplete="off" matInput required id="cargo" name="cargo"
                          [(ngModel)]="local_data.cargo" oninput="this.value = this.value.toUpperCase()"
                          placeholder="Cargo" formControlName="cargoGroup" [matAutocomplete]="autoGroup" />
                        <mat-icon matPrefix class="op-5">work</mat-icon>
                        <mat-autocomplete id="carau" name="carau" #autoGroup="matAutocomplete">
                          <mat-optgroup id="cargog" name="cargog" *ngFor="let cargogroup of cargoGroupOptions | async"
                            [label]="cargogroup.letraCargo">
                            <mat-option id="car" name="car" *ngFor="let namecargo of cargogroup.nombresCargo"
                              [value]="namecargo">
                              {{ namecargo }}
                            </mat-option>
                          </mat-optgroup>
                        </mat-autocomplete>
                      </mat-form-field>
                    </form>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </form>

        <div class="row justify-content-end">
          <div class="col-sm-12">
            <button mat-flat-button (click)="doAction()" color="accent" class="m-l-8"
              [disabled]="!userForm.valid || !unidadForm.valid || !cargoForm.valid">
              {{action}}
              <mat-icon class="m-r-10 cursor-pointer">save</mat-icon>
            </button>
            <button *ngIf="action!='Actualizar'" mat-flat-button color="primary" class="m-l-8"
              (click)="limpiarDialog()">
              Limpiar
              <mat-icon class="m-r-10 cursor-pointer" svgIcon="broom-custom"></mat-icon>
            </button>
            <button mat-flat-button style="background-color: #7f7f7f; color: white" class="m-l-8"
              (click)="closeDialog()">
              Cancelar
              <mat-icon class="m-r-10 cursor-pointer">cancel</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>